import axios from "axios";
import { getUrl } from "./urls";
import { getAccessToken } from "./utils";
import { toast } from "react-toastify";

export const SMR_REPORT_FIELD_VALUE_CHANGE = "SMR_REPORT_FIELD_VALUE_CHANGE";
export const SMR_REPORT_RESET_FIELD_VALUE = "SMR_REPORT_RESET_FIELD_VALUE";
export const SMR_REPORT_SETTINGS = "SMR_REPORT_SETTINGS";
export const SMR_REPORT_LISTS = "SMR_REPORT_LISTS";
export const SMR_REPORT_TOKENS = "SMR_REPORT_TOKENS";
export const EDIT_SMR_REPORT = "EDIT_SMR_REPORT";

export const changeSmrReportField = (field, value) => {
    return {
        type: SMR_REPORT_FIELD_VALUE_CHANGE,
        field,
        value,
    };
};

export const resetSmrReportFieldValue = (field) => {
    return {
        type: SMR_REPORT_RESET_FIELD_VALUE,
        field,
    };
};

export const getReportsSettings = () => async (dispatch) => {
    try {
        const res = await axios.get(`${getUrl("reportsConfig")}/v1/settings?access-token=${getAccessToken()}`);
        let settings = res.data.data?.filter((obj) => obj.system_name === "report_email")?.[0]?.fields?.period_value;
        // console.log("settings", settings);
        dispatch({
            type: SMR_REPORT_SETTINGS,
            payload: settings,
        });
    } catch (err) {
        console.log(err.response.data);
        if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
        else toast.error("Some Error Occured.");
        return err;
    }
};
export const getSmrReports = () => {
    const req = axios
        .get(`${getUrl("reportsConfig")}/v2?access-token=${getAccessToken()}&module_name=smr`)
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err.response.data);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: SMR_REPORT_LISTS,
        payload: req,
    };
};
export const smrTokensList = () => async (dispatch) => {
    try {
        const res = await axios.get(getUrl("social_token_list"));
        let tokens = res.data.data.tokens.filter((obj) => obj.insight_feature === 1 && obj.status === "Active");
        // .sort((a, b) => (a.account_name > b.account_name ? 1 : b.account_name > a.account_name ? -1 : 0));

        //console.log("settings", tokens);

        dispatch({
            type: SMR_REPORT_TOKENS,
            payload: tokens,
        });
    } catch (err) {
        console.log(err.response.data);
        toast.error(err.response.data?.message);

        return err;
    }
};

export const createSmrReport = (data) => async (dispatch) => {
    try {
        const req = await axios.post(`${getUrl("reportsConfig")}/v1?access-token=${getAccessToken()}`, data);
        toast.success("Report created successfully");
        dispatch({
            type: "CREATE_SMR_REPORTS",
        });
        return true;
    } catch (err) {
        console.log(err.response.data);
        toast.error(err.response.data?.message);

        return false;
    }
};

export const editSmrReport = (report) => {
    return {
        type: EDIT_SMR_REPORT,
        payload: report,
    };
};

export const updateSmrReport = (data, id) => async (dispatch) => {
    try {
        await axios.patch(`${getUrl("reportsConfig")}/v1/${id}?access-token=${getAccessToken()}`, data);
        toast.success("Report updated successfully");
        dispatch({
            type: "UPDATE_SMR_REPORT",
            // payload: tokens,
        });
    } catch (err) {
        console.log(err);
        toast.error(err.response?.data?.message);

        return err;
    }
};

export const deleteSmrReport = (id) => async (dispatch) => {
    try {
        await axios.delete(`${getUrl("reportsConfig")}/v1/${id}?access-token=${getAccessToken()}`);

        toast.success("Report deleted successfully");

        dispatch({
            type: "DELETE_SMR_REPORT",
            // payload: tokens,
        });
    } catch (err) {
        console.log(err);
        toast.error(err.response?.data?.message);

        return err;
    }
};
